/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AfterViewInit, Component, ElementRef,HostListener,Inject,Input,OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../api.service';
import { CartService } from '../services/cart.service';
import { SearchProductService } from '../services/search-product.service';
import { PopupService } from '../services/popup.service';
import { AddToCartService } from '../services/add-to-cart.service';
import { ProjectsService } from '../services/project.service';
import { Location,isPlatformBrowser } from '@angular/common';
import { OwlService } from '../services/owl.service';
import { WindowService } from '../services/window.service';

import { fadeimagesInOut } from '../animations';
import { CanonicalService } from '../shared/canonical.service';
import { ConnectService } from '../services/connect.service';
import { FormArray, FormControl } from '@angular/forms';
import { DealerService } from '../services/dealer.service';
import { LocalStorageService } from '../services/localstorage.service';
import { MessageService } from 'primeng/api';
import { Galleria } from 'primeng/galleria';
import Drift from 'drift-zoom'; // Import Drift here
import { LocationService } from '../services/location.service';
@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss'],
  animations:[fadeimagesInOut],
  providers: [MessageService]
})
export class ProductDetailComponent implements OnInit,AfterViewInit {
  global_loader = true;
  isProductLoader = true;
  productDetail: any;
  project_id: any;
  slug_name = '';
  activeImgIndex = 0;
  areaSqft: any;
  boxCount: any;
  total_Sqft_amount: any;
  quantity: any;
  is_addToCart = false;
  max_value_qty = 20;
  websiteUrl: any;
  options: any[] = [];
  attribute_list: any[] = [];
  is_top_product_header = false;
  activeTab: any = 'description';
  @ViewChild('navbar') navbar!: ElementRef;
  @Input() firstName: string = '';
  @Input() lastName: string = '';
  full_description: any;
  similar_product_list: any[] = [];
  sub_category_obj: any;
  master_attribute_list: any;
  support_product_list: any;
  product_collection_list: any[] = [];
  recentlyViewedProducts: any[] = [];
  @ViewChild('galleria') galleria!: Galleria;
  isdetailload = true;
  is_already_selected: any;
  firstproductDetailOption: any[] = [];
  secoundproductDetailOption: any[] = [];
  thirdproductDetailOption: any[] = [];
  productDetailOption: any;
  currentMaincatName: any;
  is_prospect = false;
  afterFiveDayDate: Date = new Date;
  category_name = '';
  productDetailChild: any;
  product_add_action: any;
  main_space_select_all_flag: boolean = false;
  tagged_product: any;
  isSelectProduct: boolean = false;
  main_space_list: any[] = [];
  selected_space_list: any[] = [];
  sub_category: any;
  isShowSummryBtn: boolean = false;
  activerSpaceID: any;
  tagged_in_spaces_count!: number;
  temp_product_id: any;
  currSubCatName: any;
  sub_ref_id: any;
  productSelectAllMap: Map<number, boolean> = new Map();
  productSelectedPos: { [key: number]: boolean } = {};
  seleted_productList: any[] = [];
  sysMainSpace: any;
  sysAttachedSpace: any;
  isOnMobilePlatform = false;
  temp_product_pos: any;
  prodAvl: any;
  mc_slug_name: any;
  sub_category_index!: number;
  Doneredirectononsame: any;
  redirectonsame: any;
  isrequresSpaces = false;
  isUserProductUploadet: boolean = false;
  addSpacerrorMsg: any;
  required_space_list: any;
  space_id: any;
  tagged_productlength: any;
  visibleSpaceTag: any;
  mobAddSpacedisplay: boolean = false;
  addSpacedisplay: boolean = false;
  isCloseAddSpace!: boolean;
  action_complete: boolean = false;
  isDisplayImage: boolean = false;
  container!: HTMLDivElement;
  image!: HTMLImageElement;
  sideDiv!: HTMLDivElement;
  isDealerpopup: any;
  prev_page: any;
  isProductTagToSpace: any;
  activeProdId: any;
  isAddCart: any;
  @ViewChild('compList', { static: false }) compListRef!: ElementRef;
  private _nextActionData ={};
  isOp: any;
  city: any;
  diplayNearbydealer: boolean = false;
  nearbyDealers: any[]=[];
  isConnectDealer: boolean = false;
  selectedDealer: any;
  selectedDealerIndex!: any;
  visibleAddqty=false;
  isPageLoad=false;
  displayCityPopup=false;
  activeCity_id:any;
  isLoading = false;
  install_price:number=1200;
  msgImg: any;
  isAddSampletoster:boolean=false;
  isSampleAdd:boolean=false;
  // Zoom image 
  thumbImage: string = 'https://m.media-amazon.com/images/I/71-VVH892lL._SX679_.jpg'; // Low-res image
  fullImage: string = 'https://m.media-amazon.com/images/I/71-VVH892lL._SL1500_.jpg'; // High-res image
  reviews: any;
  user_comments: any;
  stars_values = ['Why was your experience so bad?','Why was your experience so bad?','Why was your average rating experience ?','Why was your experience good?','Give a compliment']
  totalamount: number = 0;
  constructor(@Inject(PLATFORM_ID) private platformId: Object,private window: WindowService,private datas: SearchProductService, private _ar: ActivatedRoute, public _as: AppService, public _router: Router, public meta: Meta,private canonicalService:CanonicalService,
    public title: Title, public _cart: CartService, public _pop: PopupService, public _addToCartService: AddToCartService,private _connect:ConnectService,public router: Router,public locationService: LocationService,
    public _project: ProjectsService, public _location: Location, public _owlOption: OwlService,public _ds:DealerService,private localStorageService: LocalStorageService,private messageService: MessageService) {
      // if(isPlatformBrowser(platformId)){
    this.datas.currentMessage.subscribe(productDetailChild => this.productDetailChild = productDetailChild);
    const win = this.window.nativeWindow;
      if(win){
    if (win.innerWidth <= 600) {
      this.isOnMobilePlatform = true;
    // }
  }}
  
  this._as.isLoggedInSubject.subscribe((isLoggedIn:any ) => {
    if (isLoggedIn && this.isSampleAdd) {
     this.addToSampleList(this.productDetail)
    }
  });
  }

  ngOnInit(): void {
    this.productDetailChild.visibleSpaceTag = false;
    this.slug_name = this._router.url.split('/')[2].split('?')[0];
    this._ar.queryParams.subscribe(pra => {
      this.project_id = pra['pId'];
      this.isDealerpopup = pra['isDealerOfferSlider'];
      this.prev_page = pra['prev_page'];
      this.isProductTagToSpace = pra['isProductTagToSpace'];
      this.activeProdId = pra['activeProdId'];
      this.isAddCart = pra['isAddCart'];
      this.isOp=pra['isOp'];
      if (pra['qty']) {
        this.quantity = pra['qty'];
      }
    });
   
   
    if (this._as.isUserLoggedIn) {
      if (!this._project.selectedProject) {
        this._project.onDisplayProjects(false);
        return
       }else{
         this.project_id = this._project.selectedProject.id;
         this.getProduct(this.slug_name);
       }
    }else{
      this.getProduct(this.slug_name);
    }
   
    const today = new Date();
    this.afterFiveDayDate = new Date(today.setDate(today.getDate() + 5));
    // this.ViewportScroller.scrollToPosition([0, 0]);
    if (!this._as.user_location) {
      setTimeout(() => {
        this.locationService.onLocation();
      }, 3000);
      
      // return
    }
  //   if(isPlatformBrowser(this.platformId)){
  // }
  }
  ngAfterViewInit() {
    if(isPlatformBrowser(this.platformId)){
    this.onWindowScroll();
    const triggerElement = document.querySelector('.drift-demo-trigger');
        const paneContainer = document.querySelector('.detail');
    
        if (triggerElement && paneContainer) {
          new Drift(triggerElement, {
            paneContainer: paneContainer,
            inlinePane: 769,            // Switch to inline zoom at 769px
            inlineOffsetY: -85,        // Offset inline zoom pane vertically
            containInline: true,       // Ensure inline zoom is contained
            hoverBoundingBox: true     // Restrict zoom to the bounding box of the image
          });
        }
  }
  }
  getImgUrl(){
    return this.productDetail?.image_list[this.activeImgIndex].image
  }

  getInitials(firstName: string, lastName: string): string {
    const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : '';
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
    return `${firstInitial}${lastInitial}`;
  }
  getCircleProgressStyle(rating: number): string {
    const percentage = (rating / 5) * 100;
    return `conic-gradient(green ${percentage}%, lightgray ${percentage}% 100%)`;
  }

  getStrokeDasharray(rating: number): string {
    const percentage = (rating / 5) * 100;
    return `${percentage}, 100`;
  }
  @HostListener('document:scroll', ['$event'])
 onWindowScroll() {
    if(window.pageYOffset > 600){
      this.is_top_product_header = true;
    }else{
      this.is_top_product_header = false;
    }
    const tabs = ['description', 'product-details', 'compare-similar', 'compatible-products', 'combination', 'recently-viewed', 'questions-answers', 'shipping-returns', 'nearby-sallers'];
    const windowHeight = window.innerHeight;

    this.activeTab = tabs.find(tab => {
    const rect = this.getElement(tab)?.getBoundingClientRect();
    const elementMidpoint = rect ? rect.top + rect.height / 2 : -1;
    return elementMidpoint > 0 && elementMidpoint < windowHeight;
    }) || tabs[0];
  }
  
  private getElement(id: string): HTMLElement | null {
    if (isPlatformBrowser(this.platformId)) {
    return document.getElementById(id);
  }return null
  }


//   showInfo() {
//     this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Message Content' });
// }
    // Listen for Escape key globally
    @HostListener('document:keydown.escape', ['$event'])
    onEscapePressed() {
      if (this.isDisplayImage) {
        this.isDisplayImage = false;
      }
    }

  onSelectImage() {
    this.isDisplayImage = true;
  }
  getProduct(slug?: any) {
    if(this.isOp != 'true'){
      this.isProductLoader = true;
    }
    const url = this._as.api_base_url + "product/getPro/" + slug + "/?project=" + this.project_id + "&form_type='search'";
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        this.productDetail = res.product_detail;
        this.mc_slug_name = res.main_category.slug_name
        this.currentMaincatName = res.main_category;
        this.isProductLoader = false;
        this.websiteUrl = res.product_detail.website_link;
        
        this.options = res.product_detail.options;
        this.attribute_list = res.product_detail.attribute_list;
        this.full_description = res.product_detail.full_description;
        this.sub_category_obj = res.sub_category;
        this.currSubCatName = res.sub_category.name;
        this.sub_ref_id = res.product_detail.sub_category_id;
        this.support_product_list = res.product_detail.support_product_list;
        this.is_addToCart = this.productDetail.is_addtocart;
        this.product_collection_list = res.product_detail.product_collection_list;
        this.user_comments = res.product_detail.user_comments;
        if(res.product_detail?.product_calculation?.calculation_type =='meter_wise'){
          this.totalamount = res.product_detail.product_calculation.per_roll_amount;
        }
        if(this.productDetail?.image_list?.length >= 2){ 
          this.activeImgIndex = 1;
        } 
        if(this.options.length){
          for(const o of this.options){
            const currentProduct = {id:0,image:this.productDetail.image_list[this.activeImgIndex].image,name:this.getOtionValu(o),prodID:this.productDetail.id,slug_name:this.productDetail.slug_name}
            const ids = [currentProduct]
            o.option_values.forEach((ov:any)=>ids.push(ov))
            ids.sort((a, b) => a.prodID - b.prodID); 
            o.sort_op_values = ids
          }
        }
        this.addAreaWiseValue();
        this.setseoValue();

        this.isdetailload = false;
        this.is_already_selected = res.product_detail.is_already_selected;
        this.global_loader = false;
        this.getProductDetailOption();
        if (this._as.isUserLoggedIn) {
          this.getViewUpdate(this.productDetail.id)
          this.addToSpace();
          this.getRecentlyViewedProducts()
          this.onSeletedProduct();
          if (this.isAddCart == 'true' || this.isAddCart) {
            
            this.addToCart(this.productDetail);
          }
        } else {
          this.isUserProductUploadet = true;
        }
        if (this._as.user_location && !(this.isProductTagToSpace == 'true' || this.isProductTagToSpace)) {
          this.getnearbyDealer();
        }
        
        // this._cart.myListStatus();
      },
        (err: any) => {
          if(err){
            this.global_loader = false;
          }
        });
  }
  onSampleOrders(){
    this.router.navigate(['sample-order']);
    // this.instantshow();
  }
  getViewUpdate(product_id:number) {
    const url = this._as.api_base_url + 'afterbricks/view/';
    const data = {
      'product': product_id,
      'view': true
    };
    this._as.postRequest(url, data, true)
      .subscribe();
  }
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ user create projectand selected space Get Api ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //
  addToSpace() {
    this.addSpacerrorMsg = undefined;
    if (this._as.user_info.is_service_provider) {
      if (!this.project_id) {
        this._project.getProjectId();
        return
      }
    } else {
      if (!this.project_id) {
        try {
          this.project_id = JSON.parse(this.localStorageService.getItem('user_info') || "").directSearch.projectInfo.id
        } catch (e) { 
          // eslint-disable-next-line no-empty
        }
      }
    }
    this.addSpacerrorMsg = undefined;
    const url = this._as.api_base_url + 'search/selectspacelist/?project=' + this.project_id + '&sub_category=' + this.sub_ref_id;
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        this.main_space_list = res.data;
        if (!this.main_space_list.length) {
          let user_selected_space_list = []
          try{
            user_selected_space_list = JSON.parse(this.localStorageService.getItem('user_selected_space_list') || '');
          }catch{
            user_selected_space_list = []
          }
          
          if (user_selected_space_list.length) {
            this.createUserSapce(user_selected_space_list)
          } else {
            
            this.onSeletedProduct(this.productDetail);
          }
        } else {
          if (this.isProductTagToSpace == 'true' || this.isProductTagToSpace) {
            this.addProductSpace(this.productDetail,)
          }
        }
        for (const sb of this.main_space_list) {
          for (const subspace of sb.sub_space_list) {
            this.tagged_productlength = subspace.tagged_products;
            if (this.tagged_productlength.length) {
              return;
            }
          }
        }
      },
        (err: any) => {
          this.addSpacerrorMsg = "Add atleast one space from ";
          if (err.error.required_space_list && err.error.required_space_list.length > 0) {
            this.required_space_list = err.error.required_space_list;
            this.space_id = err.error.required_space_list[err.error.required_space_list.length - 1];
          }
          let user_selected_space_list = []
          try{
            user_selected_space_list = JSON.parse(this.localStorageService.getItem('user_selected_space_list') || '');
          }catch{
            user_selected_space_list = []
          }
          if (user_selected_space_list.length) {
            this.createUserSapce(user_selected_space_list)
          } else {
            this.addSpacerrorMsg = err.error.message;
          }
        });
  }
  createUserSapce(user_selected_space_list: any) {
    const url = this._as.api_base_url + 'search/addallspace/';
    const data = {
      user_selected_space_list: user_selected_space_list,
    };

    this._as.postRequest(url, data, true)
      .subscribe((res: any) => {

        if (!this.project_id || this.project_id == undefined) {
          let user_info:any;
          try{
          user_info = JSON.parse(this.localStorageService.getItem('user_info') || "");
          }catch{
            user_info = null
          }

          const directSearch = {
            isDirectSearch: true,
            is_address: false,
            projectInfo: {
              id: res.prodject_id,
              isSpaceSelected: true
            }
          }
          this._as.user_info.directSearch = directSearch
          user_info.directSearch = directSearch
          this.localStorageService.setItem('user_info', JSON.stringify(user_info));
          this.project_id = res.prodject_id
          this._router.navigate(
            [],
            {
              relativeTo: this._ar,
              queryParams: { isProductPage: false, pId: res.prodject_id },
              queryParamsHandling: 'merge',
              replaceUrl:true
            });
          this.localStorageService.removeItem('master_main_space_list')
          this.localStorageService.removeItem('user_selected_space_list')
          this.localStorageService.removeItem('redirectTo')
        }
        this.localStorageService.removeItem('master_main_space_list')
        this.localStorageService.removeItem('user_selected_space_list')
        this.localStorageService.removeItem('redirectTo')
        this.addToSpace();
      });
  }

  setseoValue() {
    this.title.setTitle(this.productDetail.name );
    this.meta.updateTag({property: 'og:title', content: this.productDetail.name+' | afterbricks.com'});
    this.meta.updateTag({property: 'og:image', content: this.productDetail?.image_list[0]?.image});
    this.meta.updateTag({property: 'og:url', content:  this._as.site_url+this._router.url})
    this.meta.updateTag({name: 'description', content:  this.productDetail.full_description})
    const attribute_list=[];
    attribute_list.push(this.productDetail.brand_name+this.productDetail.category_type.name)
    attribute_list.push(this.productDetail.category_type.name)
    if(this.productDetail.attribute_list.length){
      this.productDetail.attribute_list.forEach((pal:any)=>attribute_list.push(pal.value))
    }
    this.meta.updateTag({name: 'keywords', content: String(attribute_list)})
    this.canonicalService.setCanonicalURL();
  }
  addAreaWiseValue() {
    if (this.productDetail.calculation_type == 'sqft_wise' && this.productDetail.covered_area_par_box) {
      this.areaSqft = this.productDetail.covered_area_par_box.toFixed(2)
      this.boxCount = 1;
      if (this.productDetail.par_box_amount) {
        this.total_Sqft_amount = (this.productDetail.par_box_amount).toFixed(2);
        this.quantity = 1;
      }
      this.max_value_qty = 500;
    } else if (this.productDetail.calculation_type == 'sheet_wise' && this.productDetail.par_box_amount) {
      this.total_Sqft_amount = (this.productDetail.par_box_amount).toFixed(2);
      this.quantity = 1;
    } else {
      this.quantity = 1;
    }
  }
  areaWiseCalculat() {
    const numberToString = (((Number(this.areaSqft) / (this.productDetail.covered_area_par_box)).toFixed(2)).toString()).split('.');
    const f_number = numberToString[0];
    const s_namber = numberToString[1];
    if (Number(s_namber) >= 0) {
      this.quantity = Number(f_number) + 1
    } else {
      this.quantity = Number(f_number)
    }
    this.total_Sqft_amount = this.productDetail.par_box_amount * this.quantity;
  }
  boxWiseCalculat() {
    this.areaSqft = Number((this.productDetail.covered_area_par_box * this.quantity).toFixed(2))
    this.total_Sqft_amount = this.productDetail.par_box_amount * this.quantity;
  }
  sheetWiseCalculat() {
    this.total_Sqft_amount = this.productDetail.par_box_amount * this.quantity;
  }
  selectImg(activeImgIndex: any) {
    this.activeImgIndex = activeImgIndex;
  }
  increaseQty() {
    console.log("this.productDetail.product_calculation.calculation_type",this.productDetail.calculation_type)
    if (this.productDetail.calculation_type == "sqft_wise") {
      if (this.quantity < 5000) {
        this.quantity = Number(this.quantity) + 1;
        this.boxWiseCalculat()
        return
      }
    } else if (this.productDetail.calculation_type == "sheet_wise") {
      if (this.quantity < 5000) {
        this.quantity = Number(this.quantity) + 1;
        this.sheetWiseCalculat()
        return
      }
    }else if(this.productDetail.product_calculation.calculation_type == "meter_wise") {

      this.quantity = Number(this.quantity) + 1;
      this.totalamount = this.productDetail.product_calculation.per_roll_amount * this.quantity;
    } else {
      if (this.quantity < 20) {
        this.quantity = this.quantity + 1;
      }
    }
  }
  decreaseQty() {
    if (this.quantity > 1) {
      this.quantity = this.quantity - 1;
      if (this.productDetail.calculation_type == "sqft_wise") {
        this.boxWiseCalculat()
      } else if (this.productDetail.calculation_type == "sheet_wise") {
        this.sheetWiseCalculat()
      } else if(this.productDetail.product_calculation.calculation_type == "meter_wise"){ 
       
        this.totalamount= this.productDetail.product_calculation.per_roll_amount  * this.quantity;
      }
    
  }}
  addQty() {
    if (this.productDetail.calculation_type == "sqft_wise") {
      if (this.quantity >= 5000) {
        this.quantity = 5000;
      }
      this.boxWiseCalculat()
    } else if (this.productDetail.calculation_type == "sheet_wise") {
      if (this.quantity >= 5000) {
        this.quantity = 5000;
      }
      this.sheetWiseCalculat()
    }else if(this.productDetail.calculation_type == "meter_wise") {
      this.totalamount = this.productDetail.product_calculation.per_roll_amount  * this.quantity;
    } 
    else {
      if (this.quantity >= 20) {
        this.quantity = 20
        return
      }
    }

  }

  onOptionProduct(slug_name: any) {
    // this.global_loader=true;
    this.getProduct(slug_name)
    // const baseUrl = '/p/';
    // const newUrl = baseUrl + slug_name + this.constructQueryString();
    // this._location.go(newUrl);
  }
  // private constructQueryString(): string {
  //   let queryString = '';
  //   this._ar.queryParams.subscribe((queryParams) => {
  //     const updatedQueryParams = { ...queryParams, isOp: 'true' };
  //     queryString = '?' + Object.keys(updatedQueryParams)
  //       .map(key => `${key}=${updatedQueryParams[key]}`)
  //       .join('&');
  //   });
  //   return queryString;
  // }
  
  redirectTo(uri: string) {
    const queryParams ={ isOp:true }
    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this._router.navigate([uri],{ queryParams: queryParams }));
  }
  getOtionValu(op: any) {
    let value: any;
    try { value = this.attribute_list.find(al => al.name == op.name).value } 
    catch (e){
      // eslint-disable-next-line no-empty
     }
    return value
  }

  scroll(id?: any) {
    const element = document.getElementById(id)
    if (element) {
      this.activeTab = id;
      element.scrollIntoView();
    }
  }

  getSimilarProducts() {
    const attribute_list: any[] = [];
    for (const att of this.attribute_list) {
      attribute_list.push(att.id)
    }
    const url = this._as.api_base_url + "product/similar-product/?sub_cat_slug=" + this.sub_category_obj?.slug_name + "&slug_name=" + this.slug_name;
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        this.similar_product_list = res.products.map((prod: any) => {
          const sortedAttributeList:any = [];
          res.master_attribute_list.forEach((att: any) => {
              const attribute = prod.attribute_list.find((at: any) => at.name === att);
              if (attribute) {
                  sortedAttributeList.push(attribute);
              }
          });
          prod.attribute_list = sortedAttributeList;
          return prod;
      });
        this.master_attribute_list = res.master_attribute_list;
      },
        (err: any) => {
          if (err) {
            this.global_loader = false;
          }
          this.getdiplayAddSpace();
        });
  }
  getRecentlyViewedProducts() {
    const url = this._as.api_base_url + "product/recently-viewed/?slug_name=" + this.slug_name;
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        this.recentlyViewedProducts = res.products;
        this.updatedRecentlyViewedProducts()
      });
  }
  updatedRecentlyViewedProducts() {
    const data = {}
    const url = this._as.api_base_url + "product/recently-viewed/" + this.productDetail.id + "/";
    this._as.putRequest(url, data, true)
      .subscribe((res: any) => {
        console.log(res);
      });
  }

  getProductDetailOption() {
    this.productDetailOption = [
      {
        "key": 'Brand Name',
        "value": this.productDetail.brand_name
      },
      {
        "key": 'Product Category',
        "value": this.productDetail.category_type.name
      },
    ]
    for (const att of this.attribute_list) {
      this.productDetailOption.push({ key: att.name, value: att.value })
    }
    const space_list = [];
    for (const space of this.productDetail.applicable_spaces) {
      if (space.name.trim().length > 1) {
        space_list.push(space.name);
      }
    }
    if (this.productDetail.in_box) {
      this.productDetailOption.push({ "key": "Package Content", "value": this.productDetail.in_box + " pc" });
    }
    if (this.productDetail.weight) {
      this.productDetailOption.push({ "key": "Weight", value: this.productDetail.weight + " Kg" });
    }
    if (this.productDetail.product_class && this.productDetail.product_class != 'none') {
      this.productDetailOption.push({ "key": "Product Class", "value": this.productDetail.product_class });
    }
    if (this.productDetail.guarantee) {
      this.productDetailOption.push({ "key": "Guarantee", "value": this.productDetail.guarantee + " " + this.productDetail.guarantee_type });
    }
    if (this.productDetail) {
      if (this.productDetail.warranty) {
        this.productDetailOption.push({ "key": "Warranty", "value": this.productDetail.warranty + " " + this.productDetail.warranty_type });
        
      }
    }
    if (space_list.length) {
      this.productDetailOption.push({ "key": "Applicable", "value": space_list });
    }
  
    let first_num = this.productDetailOption.length / 2;
    if(this.productDetailOption.length % 2){
      first_num += 1
    }
    this.firstproductDetailOption = this.productDetailOption.slice(0, first_num);
    this.secoundproductDetailOption = this.productDetailOption.slice(first_num, this.productDetailOption.length);
  }
  getdiplayAddSpace() {
    if (this._as.isUserLoggedIn) {
      const prod = this.seleted_productList.find(sp => sp.id = this.productDetail.id)
      try {
        if (prod && prod.is_prospect || prod.is_addtocart) {
          this.goToProductDetail();
          return
        }
      } catch (e){
        // eslint-disable-next-line no-empty
       }
      this.productDetailChild.visibleSpaceTag = false;
      const url = this._as.api_base_url + 'search/getspace/?project=' + this.project_id;
      this._as.getRequest(url, true)
        .subscribe((res: any) => {
          this.sysMainSpace = res.main_space_list;
          this.sysAttachedSpace = res.attached_space_list;
          if (!this.project_id || this.project_id == undefined) {
            let user_info:any;
          try{
          user_info = JSON.parse(this.localStorageService.getItem('user_info') || "");
          }catch{
            user_info = null
          }
            this._as.user_info.directSearch.isDirectSearch = true;
            this._as.user_info.directSearch.is_address = false;
            user_info.directSearch.isDirectSearch = true;
            user_info.directSearch.is_address = false;

            this.localStorageService.setItem('user_info', JSON.stringify(user_info));
            this.project_id = res.projectId;
          }
          setTimeout(() => {
            this.global_loader = false;
          }, 2000);
          if (this.isOnMobilePlatform) {
            this.mobAddSpacedisplay = true;
          } else {
            this.addSpacedisplay = true;
          }
        });
    }
  }
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Add Spaces ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~  //
  addSpace(att: any, mi: any, si: any) {

    const project = this.project_id;
    const url = this._as.api_base_url + 'search/addspace/';
    let data = {};
    if (att) {
      this.sysAttachedSpace[mi].sub_space_list[si].count = 1 + this.sysAttachedSpace[mi].sub_space_list[si].count;
      const main_space_list = {
        name: this.sysAttachedSpace[mi].name,
        is_show: this.sysAttachedSpace[mi].is_show,
        id: this.sysAttachedSpace[mi].id
      };

      const sub_space_list = {

        count: this.sysAttachedSpace[mi].sub_space_list[si].count,
        balcony_ref_id: this.sysAttachedSpace[mi].sub_space_list[si].balcony_ref_id,
        name: this.sysAttachedSpace[mi].sub_space_list[si].name,
        dressing_ref_id: this.sysAttachedSpace[mi].sub_space_list[si].dressing_ref_id,
        store_room_ref_id: this.sysAttachedSpace[mi].sub_space_list[si].store_room_ref_id,
        bathroom_ref_id: this.sysAttachedSpace[mi].sub_space_list[si].bathroom_ref_id,
        id: this.sysAttachedSpace[mi].sub_space_list[si].id,
        icon: this.sysAttachedSpace[mi].sub_space_list[si].icon

      };
      data = {
        main_space_list: main_space_list,
        sub_space_list: sub_space_list,
        project: project
      };
    } else {
      this.sysMainSpace[mi].sub_space_list[si].count = 1 + this.sysMainSpace[mi].sub_space_list[si].count;
      const main_space_list = {
        name: this.sysMainSpace[mi].name,
        is_show: this.sysMainSpace[mi].is_show,
        id: this.sysMainSpace[mi].id
      };

      const sub_space_list = {

        count: this.sysMainSpace[mi].sub_space_list[si].count,
        balcony_ref_id: this.sysMainSpace[mi].sub_space_list[si].balcony_ref_id,
        name: this.sysMainSpace[mi].sub_space_list[si].name,
        dressing_ref_id: this.sysMainSpace[mi].sub_space_list[si].dressing_ref_id,
        store_room_ref_id: this.sysMainSpace[mi].sub_space_list[si].store_room_ref_id,
        bathroom_ref_id: this.sysMainSpace[mi].sub_space_list[si].bathroom_ref_id,
        id: this.sysMainSpace[mi].sub_space_list[si].id,
        icon: this.sysMainSpace[mi].sub_space_list[si].icon
      };
      data = {
        main_space_list: main_space_list,
        sub_space_list: sub_space_list,
        project: project
      };
    }

    this._as.postRequest(url, data, true)
      .subscribe((res: any) => {
        if(res){
          const rsli = this.required_space_list.findIndex((rsl: any) => rsl == this.sysMainSpace[mi].id);
          this.required_space_list.splice(rsli, 1);
          //  this.required_space_list = [];
          if (!this.required_space_list.length) {
          this.isrequresSpaces = false;

          this.addSpacerrorMsg = '';
        }
        }
      });
  }
  goToProductDetail() {
    if (this.is_addToCart) {
      // this._router.navigate(['my-list'], { queryParams: { pId: this.project_id, fl: 'search', brandId: this.productDetail.brId, slug_name: this.mc_slug_name } })
      this._router.navigate(['cart/list'], { queryParams: { pId: this.project_id, fl: 'search',} })


      
    }
  }
  closeAddSpace() {
    this.productDetailChild.visibleSpaceTag = true;
    if (this.isOnMobilePlatform) {
      this.mobAddSpacedisplay = false;
    } else {
      this.addSpacedisplay = false;
      this.productDetailChild.visibleSpaceTag = true;
    }
    if (this.project_id || this.project_id != undefined) {
      this.addToSpace();
    }
  }
  onSaveSpaces() {
    if (this.isOnMobilePlatform) {
      this.mobAddSpacedisplay = false;
    } else {
      this.addSpacedisplay = false;

    }
    this.addToSpace()
  }

  removeSpace(att: any, mi: any, si: any) {
    let id;
    if (att) {
      this.sysAttachedSpace[mi].sub_space_list[si].count = this.sysAttachedSpace[mi].sub_space_list[si].count - 1;
      id = this.sysAttachedSpace[mi].sub_space_list[si].id;
    } else {
      this.sysMainSpace[mi].sub_space_list[si].count = this.sysMainSpace[mi].sub_space_list[si].count - 1;
      id = this.sysMainSpace[mi].sub_space_list[si].id;
    }
    const url = this._as.api_base_url + 'search/del/' + id + '/?project=' + this.project_id;
    this._as.deleteRequest(url, true)
      .subscribe((res: any) => {
        console.log(res);
      },
        (err: any) => {
          console.log(err, '  error');
        });
  }

  addToCart(prod: any) {
    if (!this._as.isUserLoggedIn) {
      this._nextActionData = {
        product: this.productDetail.id,
        quantity: this.quantity,
        action_type: 'addToCart'
      }
      this._router.navigate([], {
        relativeTo: this._ar, queryParams: { isAddCart: true, qty: this.quantity },
        queryParamsHandling: 'merge',
        replaceUrl:true
      });
      setTimeout(() => {
        this._as.onLoginPage();
      }, 200);
      return
    }
    this.isSelectProduct = true;
    if (this._as.user_info.is_service_provider) {
      if (!this.project_id) {
        this._project.onDisplayProjects(false);
        return
      }
    }
    else {
      if (!this.project_id) {
        this.project_id = this._project.getProjectId();
      }
    }
    if(this.isOnMobilePlatform){
      this.visibleAddqty=true;
      return
    }
    this._cart.addToMyList(prod.id, this.quantity, this.project_id).then((res: any) => {
      this.is_addToCart = true;
      const directSearch = {
        isDirectSearch: true,
        is_address: false,
        projectInfo: {
          id: res.project_id,
          step: 1
        }
      }
      this._as.user_info.directSearch = directSearch;
      this._addToCartService.addToCart(prod)
      this._project.checkCart();
      let user_info:any;
          try{
          user_info = JSON.parse(this.localStorageService.getItem('user_info') || "");
          }catch{
            user_info = null
          }
      user_info.directSearch = directSearch;
      this.localStorageService.setItem('user_info', JSON.stringify(user_info));
      this.project_id = res.project_id;
      this.displayNotifyMessage();
      this._router.navigate([], {
        relativeTo: this._ar, queryParams: { isAddCart: null, qty: null },
        queryParamsHandling: 'merge',
        replaceUrl:true
      });
    }).catch((err: any) => {
      console.log(err);
    })

  }
  closeQty(){
    this.visibleAddqty=false;
    this._router.navigate([], {
      relativeTo: this._ar, queryParams: { isAddCart: null, qty: null },
      queryParamsHandling: 'merge',
      replaceUrl:true
    });
  }
  continueToAdd(prod:any){
this._cart.addToMyList(prod.id, this.quantity, this.project_id).then((res: any) => {
      this.is_addToCart = true;
      const directSearch = {
        isDirectSearch: true,
        is_address: false,
        projectInfo: {
          id: res.project_id,
          step: 1
        }
      }
      this._as.user_info.directSearch = directSearch;
      this._addToCartService.addToCart(prod)
      this._project.checkCart();
      let user_info:any;
          try{
          user_info = JSON.parse(this.localStorageService.getItem('user_info') || "");
          }catch{
            user_info = null
          }
      user_info.directSearch = directSearch;
      this.localStorageService.setItem('user_info', JSON.stringify(user_info));
      this.project_id = res.project_id;
      this.displayNotifyMessage();
      this._router.navigate([], {
        relativeTo: this._ar, queryParams: { isAddCart: null, qty: null },
        queryParamsHandling: 'merge',
        replaceUrl:true
      });
      this.visibleAddqty=false;
    }).catch((err: any) => {
      console.log(err);
    })

  }
  displayNotifyMessage() {
    this.action_complete = true;
    setTimeout(() => {
      this.action_complete = false
    }, 1200);
  }
  getUnitType(key:string){
    if(key==='sheet_wise'){
      return '/sqft'
    }else{
      return ''
    }
  }
  addProductSpace(prod: any, pos?: any, flag?: boolean) {
    this._router.navigate([], {
      relativeTo: this._ar, queryParams: { isProductTagToSpace: true, activeProdId: prod.id },
      queryParamsHandling: 'merge',
      replaceUrl:true
    });
    this.product_add_action = flag;
    if (this._as.isUserLoggedIn) {
      if (this.main_space_list.length) {
        this.onSeletedProduct(prod, pos);
        if (this.temp_product_id in this.productSelectAllMap) {
          this.main_space_select_all_flag = true;
        } else {
          this.main_space_select_all_flag = false;
        }
        if (pos in this.productSelectedPos) {
          delete this.productSelectedPos[pos];
        } else {
          this.productSelectedPos[pos] = true;
        }
        this.checkMainSpaceStatus();
        this.checkFOrProductAvailability('tag me');
        this.productDetailChild.visibleSpaceTag = true;
        this.datas.changeMessage(this.productDetailChild);
      } else {
        this.isrequresSpaces = true;
        if (this.Doneredirectononsame) {
          this.isrequresSpaces = false;
        }
      }
    } else {
      setTimeout(() => {
        this._as.onLoginPage();
      }, 200);
    }
  }
  onSeletedProduct(prod?: any, pos?: any) {
    this.seleted_productList = [];
    try {
      this.project_id = this.project_id = this._project.getProjectId();
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    const url = this._as.api_base_url + 'search/selectProdlist/?project=' + this.project_id + '&sub_category=' + this.sub_ref_id;
    this._as.getRequest(url, true)
      .subscribe((res: any) => {
        if (prod) {
          const pro_check = res.seleted_productList.filter((pr: any) => pr.id == prod.id);
          if (!pro_check.length) {
            this.seleted_productList.push(prod);
            this.tagged_product = prod;
            this.temp_product_id = prod.id;
            this.temp_product_pos = pos;
            this.onClickSeletedProduct(prod);
          } else if (!res.seleted_productList.length) {
            this.seleted_productList.push(prod);
            this.tagged_product = prod;
            this.temp_product_id = prod.id;
            this.temp_product_pos = pos;
            this.onClickSeletedProduct(prod);
          } else {
            this.tagged_product = prod;
            this.temp_product_id = prod.id;
            this.onClickSeletedProduct(prod);
          }
        }
       
        for (const obj of res.seleted_productList) {
          if (!this.seleted_productList.find(sp => sp.id == obj.id)) {
            this.seleted_productList.push(obj);
          }
        }
        this.prodAvl = res.seleted_productList.find((spl: any) => spl.id == this.productDetail.id)
        try {
          this.is_addToCart = this.prodAvl.is_addtocart;
          this.is_prospect = this.prodAvl.is_prospect;
        } catch (e){
          // eslint-disable-next-line no-empty
        }
        this.isdetailload = false;
      });
  }
  checkMainSpaceStatus() {
    if (this.seleted_productList.find(spl => spl.id == this.tagged_product.id)) {
      if (this.sub_category_index >= 0) {
        for (let j = this.main_space_list.length - 1; j >= 0; j--) {
          let isNotFound = false;
          for (let i = this.main_space_list[j].sub_space_list.length - 1; i >= 0; i--) {
            const fin = this.main_space_list[j].sub_space_list[i].tagged_products.findIndex((item: any) => item.id == this.tagged_product.id);
            if (fin < 0) {
              isNotFound = true;
              break;
            }
          }
          if (isNotFound) {
            this.main_space_list[j].is_selected = false;
          } else {
            this.main_space_list[j].is_selected = true;
          }
        }
      }
    }
  }
  checkFOrProductAvailability(key: any, id?: any) {
    if (id) {
      this.temp_product_id = id;

      for (let i = 0; i < this.main_space_list.length; i++) {
        for (let j = 0; j < this.main_space_list[i].sub_space_list.length; j++) {
          this.main_space_list[i].sub_space_list[j].is_product_available = false;
        }
      }
      for (let i = 0; i < this.main_space_list.length; i++) {
        for (let j = 0; j < this.main_space_list[i].sub_space_list.length; j++) {
          const fin = this.main_space_list[i].sub_space_list[j].tagged_products.findIndex((item: any) => item.id == this.temp_product_id);
          if (fin >= 0) {
            this.main_space_list[i].sub_space_list[j].is_product_available = true;
          }
        }
      }
      const proi = this.seleted_productList.findIndex(spl => spl.id == this.temp_product_id);
      this.seleted_productList.splice(proi, 1);
    }
  }

  onSelecteAllSpace(main_space_select_all_flag: boolean) {
    this.isSelectProduct = true;
    this.selected_space_list = [];
    if (main_space_select_all_flag) {
      for (const ms of this.main_space_list) {
        ms.is_selected = true;
        for (const ss of ms.sub_space_list) {
          ss.is_selected = true;
          ss.tagged_products.push(this.productDetail);
          this.selected_space_list.push(ss.id);
        }
      }
      this.checkAllSpace();
      const url = this._as.api_base_url + 'search/add-to-cart-product/';
      if (!this.project_id) {
        this.project_id = this.project_id = this._project.getProjectId();
      }
      const my_data = {
        project: this.project_id,
        sub_category: this.sub_category,
        sub_space_list: this.selected_space_list,
        product: this.productDetail.id,
        is_status: main_space_select_all_flag,
        form_type: 'all',
        product_add_action: this.product_add_action
      };
      this._as.postRequest(url, my_data, true)
        .subscribe((res: any) => {
          if(res){
            this.isSelectProduct = false;
            this.isShowSummryBtn = false;
            this.onClickSeletedProduct(this.productDetail);
            this.isSelectProduct = false;
          }
        },
          (err: any) => {
            if(err){
              this.isSelectProduct = false;
            }
          });
    } else {
      for (let i = 0; i < this.main_space_list.length; i++) {
        this.main_space_list[i].is_selected = false;
        for (let j = 0; j < this.main_space_list[i].sub_space_list.length; j++) {
          const fin = this.main_space_list[i].sub_space_list[j].tagged_products.findIndex((item: any) => item.id == this.productDetail.id);
          this.main_space_list[i].sub_space_list[j].tagged_products.splice(fin, 1);
          this.main_space_list[i].sub_space_list[j].is_selected = false;
          this.selected_space_list.push(this.main_space_list[i].sub_space_list[j].id);
        }
      }
      this.checkAllSpace();
      const url = this._as.api_base_url + 'search/add-to-cart-product/';
      if (!this.project_id) {
        this.project_id = this.project_id = this._project.getProjectId();
      }
      const my_data = {
        project: this.project_id,
        sub_category: this.sub_category,
        sub_space_list: this.selected_space_list,
        product: this.productDetail.id,
        is_status: main_space_select_all_flag,
        form_type: 'all',
        product_add_action: this.product_add_action
      };
      this._as.postRequest(url, my_data, true)
        .subscribe((res: any) => {
          if(res){
            this.isShowSummryBtn = false;
            this.onClickSeletedProduct(this.productDetail);
            this.isSelectProduct = false;
          }
        },
          (err: any) => {
            if(err){
            this.isSelectProduct = false;
            }
          });
    }
  }
  redirectToSelectSpace(mId: any) {
    this.localStorageService.removeItem('addTask')
    let paramsObject: any;
    this._ar.queryParamMap
      .subscribe((params) => {
        paramsObject = { ...params };
      });
    const redirectTo = {
      link: this._router.url.split('?')[0],
      queryParams: paramsObject.params
    }
    this.localStorageService.setItem('redirectTo', JSON.stringify(redirectTo));
    if (this.project_id) {
      this._router.navigate(['../../house-spaces'], { queryParams: { pId: this.project_id, isCbackprod: true, activemsid: mId } })
    } else {
      this._router.navigate(['../../house-spaces'], { queryParams: { isCbackprod: true, activemsid: mId } })
    }
  }

  onTagAllSubSpace(flag: boolean, msi: any) {
    this.isSelectProduct = true;
    this.selected_space_list = [];
    if (flag) {
      this.main_space_list[msi].is_selected = true;
      this.main_space_list[msi].sub_space_list.forEach((ss: any) => {
        const proAvl = ss.tagged_products.find((tp: any) => tp.id == this.productDetail.id);
        if (!proAvl) {
          ss.is_selected = true;
          ss.tagged_products.push(this.productDetail);
          this.selected_space_list.push(ss.id);
        }
      });
      const url = this._as.api_base_url + 'search/add-to-cart-product/';
      if (!this.project_id) {

        this.project_id = this.project_id = this._project.getProjectId();
      }
      this.checkAllSpace();
      const my_data = {
        project: this.project_id,
        sub_category: this.sub_category,
        sub_space_list: this.selected_space_list,
        product: this.productDetail.id,
        is_status: flag,
        form_type: 'all',
        product_add_action: this.product_add_action
      };
      this._as.postRequest(url, my_data, true)
        .subscribe((res: any) => {
          if(res){
            this.isShowSummryBtn = false;
            this.onClickSeletedProduct(this.productDetail);
            this.isSelectProduct = false;
          }
        },
          (err: any) => {
            if(err){
              this.isSelectProduct = false;
            }
          });
    } else {
      this.main_space_list[msi].is_selected = false;
      for (let j = 0; j < this.main_space_list[msi].sub_space_list.length; j++) {
        const fin = this.main_space_list[msi].sub_space_list[j].tagged_products.findIndex((item: any) => item.id == this.productDetail.id);
        this.main_space_list[msi].sub_space_list[j].tagged_products.splice(fin, 1);
        this.main_space_list[msi].sub_space_list[j].is_selected = false;
        this.selected_space_list.push(this.main_space_list[msi].sub_space_list[j].id);
      }
      this.checkAllSpace();
      const url = this._as.api_base_url + 'search/add-to-cart-product/';
      if (!this.project_id) {
        this.project_id = this.project_id = this._project.getProjectId();
      }
      const my_data = {
        project: this.project_id,
        sub_space_list: this.selected_space_list,
        product: this.productDetail.id,
        is_status: flag,
        form_type: 'all',
        product_add_action: this.product_add_action
      };
      this._as.postRequest(url, my_data, true)
        .subscribe((res: any) => {
          if(res){
            this.isShowSummryBtn = false;
            this.onClickSeletedProduct(this.productDetail);
            this.isSelectProduct = false;
          }
        },
          (err: any) => {
            if(err){
              this.isSelectProduct = false;
            }
          });
    }
  }
  onHoverSpace(id: any) {
    this.activerSpaceID = id;
  }
  onAddProductToSpace(ss_id: any, status: boolean, ms_index: number, ss_index: number) {
    this.isSelectProduct = true;

    const url = this._as.api_base_url + 'search/add-to-cart-product/';
    if (!this.project_id) {
      this.project_id = this.project_id = this._project.getProjectId();
    }
    if (status) {
      this.main_space_list[ms_index].sub_space_list[ss_index].tagged_products.push(this.productDetail)
    } else {
      const fin = this.main_space_list[ms_index].sub_space_list[ss_index].tagged_products.findIndex((item: any) => item.id == this.productDetail.id);
      this.main_space_list[ms_index].sub_space_list[ss_index].tagged_products.splice(fin, 1);
    }
    const my_data = {
      project: this.project_id,
      sub_space: ss_id,
      product: this.productDetail.id,
      is_status: status,
      product_add_action: this.product_add_action
    };
    this.checkAllSpace();
    this._as.postRequest(url, my_data, true)
      .subscribe((res: any) => {
        if(res){
          this.isSelectProduct = false;
          this.onClickSeletedProduct(this.productDetail);
          this.isShowSummryBtn = false;
        }
      },
        (err: any) => {
          if(err){
            this.isSelectProduct = false;
          }
        });
  }
  onClickSeletedProduct(prod: any) {
    this.tagged_in_spaces_count = 0;
    for (const msl of this.main_space_list) {

      for (const ssl of msl.sub_space_list) {
        const product = ssl.tagged_products.filter((stp: any) => stp.id == prod.id);

        if (product.length) {
          ssl.is_selected = true;
          this.tagged_in_spaces_count += 1;
        } else {
          ssl.is_selected = false;
        }
        const mslp = msl.sub_space_list.filter((sp: any) => sp.is_selected == true);
        if (mslp.length == msl.sub_space_list.length) {
          msl.is_selected = true;
        } else {
          msl.is_selected = false;
        }
      }
    }
    this.checkAllSpace();
    this.tagged_product = prod;
    this.temp_product_id = prod.id;
  }
  checkAllSpace() {
    const mslist = this.main_space_list.filter(ms => ms.is_selected == true);
    if (mslist.length == this.main_space_list.length) {
      this.main_space_select_all_flag = true;
    } else {
      this.main_space_select_all_flag = false;
    }
  }

  space_review() {
    let paramsObject: any;
    this._ar.queryParamMap
      .subscribe((params) => {
        paramsObject = { ...params };
      });
    const redirectTo = {
      link: this._router.url.split('?')[0],
      queryParams: paramsObject.params
    }
    this.localStorageService.setItem('redirectTo', JSON.stringify(redirectTo));
    // this._router.navigate([`collection/` + this.currentMaincatName.slug_name], { queryParams: { pId: this.project_id, subCat: this.sub_category, activeFlow: 'search' } });
    this._router.navigate([`as-collection/`], { queryParams: { pId: this.project_id, subCat: this.sub_category, activeFlow: 'search', wId: this.slug_name } });
  }
  oncloseAddPro(flag: any) {
    this._project.checkCart();
    this.localStorageService.removeItem("addTask")
    // const redirectonsame = JSON.parse(this.localStorageService.getItem('redirectonsame'));

    if (!flag) {
      this.visibleSpaceTag = false;
      this.productDetailChild = {
        isDetailPage: false
      };
    } else {
      this.visibleSpaceTag = false;
      this.productDetailChild = {
        isDetailPage: false
      };
      let isproductback=false
      try{
        isproductback = JSON.parse(this.localStorageService.getItem('isproductback') || '');
      }catch{
        isproductback = false;
      }
      
      // if (!redirectonsame) {
      //   console.log('test===>4')
      //   this.redirectUserPreviousAct()
      // }
      if (isproductback) {
        isproductback = false;
        this.localStorageService.setItem('isproductback', JSON.stringify(isproductback));
        this.redirectUserPreviousAct()
      } else {
        this.redirectUserPreviousAct()
      }
    }
    
    let Doneredirectononsame:any
    try{
      Doneredirectononsame = JSON.parse(this.localStorageService.getItem('Doneredirectononsame') || '');
    }catch{
      Doneredirectononsame = false
    }
    if (Doneredirectononsame) {
      this.localStorageService.removeItem('redirectTo');
      Doneredirectononsame = false;
      this.localStorageService.setItem('Doneredirectononsame', JSON.stringify(Doneredirectononsame));
    }
  }

goToDeptPage(){
 
  this._router.navigate([`department/` + this.currentMaincatName.slug_name]);
}
  onBreadcrumb() {
    let redirectTo :any
    try{
      redirectTo = JSON.parse(this.localStorageService.getItem('redirectTo') || '')
    }catch{
      console.log("err")
    }
    if (redirectTo) {
      this.redirectUserPreviousAct()
    }
    else {
      this._location.back()
    }
  }

  onBack() {
    this._router.navigate([`product/` + this.currentMaincatName.slug_name], { queryParams: { pId: this.project_id, subCat: this.sub_ref_id } });
    // this.redirectUserPreviousAct()
  }
  redirectUserPreviousAct() {
    try{
      const redirectTo = JSON.parse(this.localStorageService.getItem('redirectTo') || '');
      this._router.navigate([redirectTo?.link], { queryParams: redirectTo?.queryParams })
      this.localStorageService.removeItem("redirectTo")
    } catch{
      this._router.navigate([`product/` + this.currentMaincatName.slug_name], { queryParams: { pId: this.project_id, subCat: this.sub_ref_id } });
    }
  }
  goToSaveIdea() {
    this._router.navigate(['saved-ideas/' + this.mc_slug_name], { queryParams: { pId: this.project_id, fl: 'search' } })
  }
  onBackProductPage() {
    let redirectonsame:any;
    try{
     redirectonsame = JSON.parse(this.localStorageService.getItem('redirectonsame') || '');
    }catch{
      console.log("except ")
    }
    if (!redirectonsame) {
      this._router.navigate([`product/` + this.currentMaincatName.slug_name], { queryParams: { pId: this.project_id, subCat: this.sub_ref_id } });
    } else {
      this._router.navigate([redirectonsame.link], { queryParams: { subCat: redirectonsame.subCat, att: redirectonsame.att, brand: redirectonsame.brand, isBrandSL: redirectonsame.isBrandSL, page: redirectonsame.page, sortby: redirectonsame.sortby } })
    }
  }

  getRequired(id: number) {
    if (this.required_space_list.length) {
      const getRequiredspace = this.required_space_list.find((rsl: any) => rsl == id);
      if (getRequiredspace) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  scrollPrev(): void {
    this.compListRef.nativeElement.scrollLeft -= 337;
    if (this.compListRef.nativeElement.scrollLeft == 0) {
      const el = document.querySelector('.scroll-prev-btn')
      if(el){
      el.setAttribute("style", "opacity:0.5");}
    }
  }

  scrollNext(): void {
    if (isPlatformBrowser(this.platformId)) {
    this.compListRef.nativeElement.scrollLeft += 337;
    if (this.compListRef.nativeElement.scrollLeft <= 337) {
      const el = document.querySelector('.scroll-prev-btn')
      if(el){
      el.setAttribute("style", "opacity:1");
      }
    }
  }
  }
  getnearbyDealer(){
    const url = this._as.api_base_url + 'product/nearby-dealer/';
    const my_data = {
      city: this.city,
      product: this.productDetail.id,
      lat: this._as.user_location.latitude,
      long: this._as.user_location.longitude,
      distance:50,
      slug_name:this.slug_name,
      project:this._project.selectedProject?.id
    };
    this.checkAllSpace();
    this._as.postRequest(url, my_data, true)
      .subscribe((res: any) => {
       this.nearbyDealers = res.data;
       
      //  setTimeout(() => {
      //   if(!this.localStorageService.getItem('isNearbydealerOpen')){
      //     this.diplayNearbydealer = true;
      //     this.localStorageService.setItem('isNearbydealerOpen','true');
      //   }
      // }, 3500);
      },
        (err: any) => {
          if(err){
            this.isSelectProduct = false;
          }
        });
  }
  shownearbyDealers(){
    this.diplayNearbydealer = true;
  }
  hideNearbySlider(){
    this.diplayNearbydealer = false;
  }
  onconnect(event:MouseEvent,dealer:any, di:number){
    event.preventDefault();
    this.isConnectDealer = true;
    this.selectedDealer= dealer;
    this.selectedDealerIndex = di;
    this.diplayNearbydealer=false;
    event.stopPropagation();
    // if(!this._as.isUserLoggedIn){
    //   this._as.isDisplayLogin = true;
    // }
    this._router.navigate([`dealer/`+ dealer.slug_name], { queryParams: {isConnectDealer:true}});
  }
  getDealText(){
    if(this.nearbyDealers.length <= 1){
      return 'Live offer from seller'
    }else{
      return 'Live offers from sellers'
    }

  }
  onDealerCardClick(dealerId: string) {
    // Navigate to the desired route when the dealer card is clicked
    this._router.navigate(['../../dealer', dealerId]);
  }
  connectDealerTopffer(form_type:string){
    const data = {
      "dealer":this.selectedDealer.id,
      "project":this._project.selectedProject?.id,
      "product":this.productDetail.id,
      "form_type":form_type
    }
    const url = this._as.api_base_url + "user/dealer-connect/";
    this._as.postRequest(url, data, true)
      .subscribe((res: any) => {
        this.nearbyDealers[this.selectedDealerIndex].discount = res.dealer_discount;
        this.nearbyDealers[this.selectedDealerIndex].is_connect =true;
        this.isConnectDealer = false;
        this.selectedDealerIndex = undefined;
      });
  }
  onNearByDealerClick(){
    if (isPlatformBrowser(this.platformId)) {
    const element = document.getElementById("nearby-sallers");
    element?.scrollIntoView();  
    this.diplayNearbydealer=false; 
  }
  }
  getRdUrl(prod:any){
    const url=this._as.site_url + "/product/"+this.currentMaincatName?.slug_name+'?subCat='+this.sub_category_obj.id+'&category='+prod?.product_type_id+'&pId='+this.project_id;
    return url
  }
  onRequest(key:string){
    this._connect.productPageSubject=key;
    if(this._as.isUserLoggedIn){
      this._connect.setFormValues();
    }
    this._connect.connect_item_image_url = this.productDetail?.image_list[0]?.image;
    this._connect.connect_item_name = this.productDetail?.name;
    if(key){
      const requestArray=this._connect.connectForm.get('subject') as FormArray;
      requestArray.clear(); 
      requestArray.push(new FormControl(key))
    }
    this._connect.getConnectData(this.productDetail);
  }
  onCatalogue(){
    window.open(this.productDetail?.catelogue, '_blank');
  }
  onSelectCity(cityId:any){
    this.activeCity_id = cityId;
    console.log(this.productDetail)
    this._router.navigate([`dealer`], { queryParams: {cityId:this.activeCity_id, mcId: this.currentMaincatName.id, brandId: this.productDetail?.brId ,page:1} });
  }

  addToSampleList(product:any){
    if(!this._as.isUserLoggedIn){
      this.isSampleAdd = true;
      this._as.isDisplayLogin = true;
      return
    }
    if (product.slug) {
      const data = {
        product_slug_name: product.slug,
      }
      const url = this._as.api_base_url + 'ims/cart/';
      this._as.postRequest(url, data, true).subscribe(
        () => {
          this.msgImg = this.productDetail?.image_list[0]?.image;
          this.productDetail.sample_status="Booked"
          this.isAddSampletoster = true;
         setTimeout(() => {
          this.isAddSampletoster = false;
         }, 2000);
          this._cart.getSampleCartStatus();
        },
        (err: any) => {
          console.log("Error =>",err)
          this.messageService.add({ severity: 'warn',
            summary: 'Upgrade Required',
            detail: 'Upgrade to Pro to book samples.',
            life: 4000,
            closable: true,
            data: { url: 'https://pro.afterbricks.com/account/join-as' },});
        }
      )
    } else {
      alert('Please fill in all required fields!');
    }
  }
  openSampleCart(){
    this._router.navigate(['sample-checkout/list'])
  }

  getPercentage(count: number): number {
    const total = this.productDetail?.questions_answers?.reduce((sum:any, q:any) => 
      sum + q.answers.reduce((aSum:any, a:any) => aSum + a.answer_count, 0), 0
    );
    return total ? (count / total) * 100 : 0;
  }
  @HostListener("window:scroll", ["$event"])
      getScrollHeight(): void {
        if (isPlatformBrowser(this.platformId)) {
        if (window.innerHeight + window.scrollY >= 1270 && !this.isLoading) {
          
          this.isLoading = true;
          this.getSimilarProducts();
        }
      }
    }
}
